import React, { useState } from 'react';
import { Stack, Modal } from 'react-bootstrap';
import Button from 'components/base/Button';
import axiosInstance from 'utils/axiosInterceptors';
import { toast } from 'react-toastify';
import { toastConfig } from 'utils/toastConfig';
import { AxiosError } from 'axios';

const Gates = () => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const handleOpen = async () => {
    try {
      const res = await axiosInstance.get('/api/v1/gates/open');
      toast.success(res.data, {
        ...toastConfig,
        autoClose: 2000
      });
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage || 'An error occurred', {
          ...toastConfig,
          autoClose: 3000
        });
      } else {
        toast.error('An unexpected error occurred', {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  const handleClose = async () => {
    setIsDialogOpen(true);
  };

  const handleCancel = () => {
    console.log('Action canceled.');
    setIsDialogOpen(false);
  };

  const handleCloseConfirm = async () => {
    try {
      const res = await axiosInstance.get('/api/v1/gates/close');
      toast.success(res.data, {
        ...toastConfig,
        autoClose: 2000
      });
      setIsDialogOpen(false);
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage || 'An error occurred', {
          ...toastConfig,
          autoClose: 3000
        });
      } else {
        toast.error('An unexpected error occurred', {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  const handleStop = async () => {
    try {
      const res = await axiosInstance.get('/api/v1/gates/stop');
      toast.success(res.data, {
        ...toastConfig,
        autoClose: 2000
      });
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage || 'An error occurred', {
          ...toastConfig,
          autoClose: 3000
        });
      } else {
        toast.error('An unexpected error occurred', {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  return (
    <>
      <Stack className="flex-center content-min-h">
        <div className="text-center py-4">
          <Button onClick={handleOpen} className="btn btn-lg btn-primary" style={{ width: '200px' }}>
            Open Gate
          </Button>
        </div>
        <div className="text-center py-4">
          <Button onClick={handleStop} className="btn btn-lg btn-warning" style={{ width: '200px' }}>
            Stop
          </Button>
        </div>
        <div className="text-center py-4">
          <Button onClick={handleClose} className="btn btn-lg btn-danger" style={{ width: '200px' }}>
            Close Gate
          </Button>
        </div>
      </Stack>

      <Modal show={isDialogOpen} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Gate Close</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">Make sure that the gate is all clear before closing.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleCloseConfirm}>
            Close Gate
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Gates;
